/**
 * SettlementDetails Component
 *
 * Pure UI Component for displaying employee settlement information
 * Contains all tables and inner actions (Add/Save within sections)
 * NO outer action buttons (Cancel/Proceed/Print)
 *
 * Used by:
 * - FinalExitDetails (with action buttons)
 * - SettlementPreviewDetails (with print button)
 */

import React, { useState } from "react";
import EmpDetailsSection from "./sections/EmpDetailsSection";
import ContractHistorySection from "./sections/ContractHistorySection";
import WorkHistorySection from "./sections/WorkHistorySection";
import IdleHistorySection from "./sections/IdleHistorySection";
import RepatriationSection from "./sections/RepatriationSection";
import StatementSection from "./sections/StatementSection";
import FinancialStatementSection from "./sections/FinancialStatementSection";

const SettlementDetails = ({
  employeeID,
  data,
  trigger,
  setTrigger,
  isLocalExit = false,
  baseEndpoint = '/mobilization',
  repatration,
  updateNew,
  repatriationAmount,
  setRepatriationAmount,
  repatriationSaved,
  setRepatriationSaved,
  selectedRepatrationType,
  setSelectedRepatrationType,
  fandftrigger,
  setFandfTrigger,
  isPreviewMode = false, // New prop to disable edits in preview mode
}) => {
  // State to store F&F Settlement Total from Statement component
  const [ffSettlementTotal, setFfSettlementTotal] = useState(0);

  // Callback handler with logging
  const handleFfSettlementTotalChange = (total) => {
    console.log("SettlementDetails - Received F&F Settlement Total:", total);
    setFfSettlementTotal(total);
  };
  return (
    <div className="space-y-4">
      {/* Employee Details Section */}
      <EmpDetailsSection
        data={data}
        setTrigger={setTrigger}
        trigger={trigger}
        isLocalExit={isLocalExit}
        baseEndpoint={baseEndpoint}
        isPreviewMode={isPreviewMode}
      />

      {/* Contract History Section */}
      <ContractHistorySection data={data} />

      {/* Work History Section */}
      <WorkHistorySection data={data} />

      {/* Idle History Section */}
      <IdleHistorySection data={data} />

      {/* Repatriation Section */}
      <RepatriationSection
        repatration={repatration}
        repatrationdata={data}
        updateNew={updateNew}
        isLocalExit={isLocalExit}
        baseEndpoint={baseEndpoint}
        setRepatriationAmount={setRepatriationAmount}
        setRepatriationSaved={setRepatriationSaved}
        setSelectedRepatrationType={setSelectedRepatrationType}
        trigger={trigger}
        setTrigger={setTrigger}
        isPreviewMode={isPreviewMode}
      />

      {/* F&F Statement Section */}
      <StatementSection
        data={data}
        isLocalExit={isLocalExit}
        employeeID={employeeID}
        onTotalChange={handleFfSettlementTotalChange}
      />

      {/* Financial Statement Section */}
      <FinancialStatementSection
        data={data}
        fandftrigger={fandftrigger}
        setFandfTrigger={setFandfTrigger}
        isLocalExit={isLocalExit}
        baseEndpoint={baseEndpoint}
        repatriationAmount={repatriationAmount}
        repatriationSaved={repatriationSaved}
        selectedRepatrationType={selectedRepatrationType}
        isPreviewMode={isPreviewMode}
        ffSettlementTotal={ffSettlementTotal}
      />
    </div>
  );
};

export default SettlementDetails;
